{
  "INTEGRATION_APPS": {
    "FETCHING": "正在取得整合",
    "NO_HOOK_CONFIGURED": "此帳戶中尚未設定 {integrationId} 整合。",
    "HEADER": "應用程式",
    "COUNT": "{n} 個整合 | {n} 個整合",
    "SEARCH_PLACEHOLDER": "搜尋...",
    "NO_RESULTS": "找不到符合搜尋條件的結果",
    "STATUS": {
      "ENABLED": "已啟用",
      "DISABLED": "已停用"
    },
    "CONFIGURE": "設定",
    "ADD_BUTTON": "新增掛鉤",
    "DELETE": {
      "TITLE": {
        "INBOX": "刪除確認",
        "ACCOUNT": "取消連接"
      },
      "MESSAGE": {
        "INBOX": "您確定要刪除嗎？",
        "ACCOUNT": "您確定要取消連接嗎？"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "是，刪除",
        "ACCOUNT": "是，取消連接"
      },
      "CANCEL_BUTTON_TEXT": "取消",
      "API": {
        "SUCCESS_MESSAGE": "掛鉤刪除成功",
        "ERROR_MESSAGE": "無法連接伺服器，請稍後再試"
      }
    },
    "LIST": {
      "FETCHING": "正在取得整合掛鉤",
      "INBOX": "收件匣",
      "ACTIONS": "操作",
      "DELETE": {
        "BUTTON_TEXT": "刪除"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "選擇收件匣",
          "PLACEHOLDER": "選擇收件匣"
        },
        "SUBMIT": "建立",
        "VALIDATING_OPENAI": "Validating with OpenAI...",
        "CANCEL": "取消"
      },
      "API": {
        "SUCCESS_MESSAGE": "整合掛鉤新增成功",
        "ERROR_MESSAGE": "無法連接伺服器，請稍後再試"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "連接"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "取消連接"
    },
    "SIDEBAR_DESCRIPTION": {
      "DIALOGFLOW": "Dialogflow 是一個用於建立對話介面的自然語言處理平台。將其與 {installationName} 整合後，機器人可以先處理查詢，並在需要時將其轉接給客服。它有助於篩選潛在客戶，並透過回答常見問題來減輕客服的工作量。若要新增 Dialogflow，請在 Google Console 中建立服務帳戶並分享憑證。詳情請參閱文件"
    }
  }
}
